import { Select, SelectProps, Space, Typography } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";
import color from "../../../theme/color";
import { ArrowChevronDown, InterfaceCheck } from "../Icon";
import { IconForm } from "../Icon/index.styled";
import { SelectWrapStyled } from "./Search.styled";

export interface CustomSearchSelectProps extends SelectProps {
  prefix?: React.ReactNode;
}

/**
 * 검색용 커스텀 셀렉트박스
 * @param param0
 * @returns
 */
export const CustomSearchSelect: React.FC<CustomSearchSelectProps> = ({
  prefix,
  style,
  ...props
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [focus, setFocus] = useState(false);
  const [left, setLeft] = useState(0); // prefix icon (23) + marginleft 4

  const labelPrefix = useMemo(() => {
    if (prefix) {
      const multiple = !!props.mode;
      const isValue = multiple ? !!props.value?.length : props.value?.trim();
      return (
        <span ref={ref} className="prefix-icon-wrapper">
          <Space size={6} style={{ marginRight: 4 }}>
            {prefix}
            {isValue && props?.placeholder && focus === false && (
              <Typography.Text style={{ fontWeight: 700, color: color.gray4 }}>
                {props.placeholder}
              </Typography.Text>
            )}
          </Space>
        </span>
      );
    }
    return undefined;
  }, [prefix, props, focus]);

  useEffect(() => {
    setLeft(ref?.current?.clientWidth || (prefix ? 28 : 0));
  }, [ref.current, focus, props.value]);

  const classNames = useMemo(() => {
    const names = [];

    if (props.value) {
      names.push("has-values");
    }
    if (props.mode === "multiple") {
      names.push("multiple");
    }

    return names.join(" ");
  }, [props]);

  return (
    <SelectWrapStyled left={left}>
      {labelPrefix && labelPrefix}
      <Select
        maxTagCount="responsive"
        className={classNames}
        onDropdownVisibleChange={(open) => {
          setFocus(open);
        }}
        onClear={() => {
          setLeft(prefix ? 28 : 0);
        }}
        suffixIcon={
          <IconForm component={ArrowChevronDown} color={color.gray4} />
        }
        menuItemSelectedIcon={
          <IconForm
            component={InterfaceCheck}
            color={color.primary3}
            style={{ fontSize: 16 }}
          />
        }
        {...props}
        style={{ height: 32, ...style }}
      />
    </SelectWrapStyled>
  );
};
